import {DoctorVisitsItemType} from 'domain/usecases/private/my-hospitalization/get-doctor-visits-list';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useDebounceSearch} from 'presentation/hooks/useDebounceSearch';
import {useGetPaginatedItemsReactQuery} from 'presentation/pages/private/hooks/useGetPaginatedItemsReactQuery';
import {getDoctorVisitsList} from '../services/getDoctorVisitsList';

const SIZE = 6;

export const useDoctorVisits = () => {
	const {searchValueState, debouncedQueryFunc, clearSearchParams, abortDebounce} =
		useDebounceSearch({});

	const {
		items,
		loadingItemsList,
		itemsListIsEmpty,
		itemsListHasError,
		totalItems,
		loadMore,
		resetState,
		refresh,
		isLoading,
	} = useGetPaginatedItemsReactQuery<DoctorVisitsItemType>({
		queryKey: [QUERY_KEYS.HOSPITALIZATION_DOCTOR_VISITS_LIST, searchValueState],
		queryFn: ({page}) =>
			getDoctorVisitsList({
				'doctor-name': searchValueState.toUpperCase(),
				page,
				size: SIZE,
			}),
	});

	return {
		items,
		loadingItemsList,
		isLoading,
		itemsListIsEmpty,
		itemsListHasError,
		totalItems,
		loadMore,
		resetState,
		refresh,
		searchValueState,
		debouncedQueryFunc,
		clearSearchParams,
		abortDebounce,
	};
};
